import {Component, ViewChild} from '@angular/core';
import {MatMenuTrigger} from '@angular/material/menu';

@Component({
  selector: 'app-status-contextual-menu',
  templateUrl: './status-contextual-menu.component.html',
  styleUrls: ['./status-contextual-menu.component.scss']
})
export class StatusContextualMenuComponent {

  @ViewChild(MatMenuTrigger)
  public trigger: MatMenuTrigger;

  public get isOpen(): boolean {
    return this.trigger?.menuOpen || false;
  }

}
